/** Copyright (c) 2020 T. Rowe Price. All rights reserved. */

import React from 'react';
import './Banner.scss';

const Banner = ({ className, arrow = true, children }) => {
  return (
    //We don't use section much if at all but is ok to use it here?
    <section className={'arrow-banner ' + className}>
      {arrow && <div className="arrow" />}
      {children}
    </section>
  );
};

export default Banner;
